import { Box, Grid, Typography } from "@mui/material";
import { useGetActiveRafflesQuery } from "../../store/api";
import { useAppSelector } from "../../store/hooks/useAppSelector";
import { IRaffle } from "../../store/interfaces/IRaffle";
import { RootState } from "../../store/types/rootState";
import { getPrimaryColorByAccountId } from "../../utils/styleConstants";
import { Loading } from "../layout/loading";
import { NoActiveRaffle } from "./NoActiveRaffle";
import { PublicRaffleCard } from "./PublicRaffleCard";

interface RaffleCatalogProps {
  title?: string;
  getHref?: (raffle: IRaffle) => string;
}

export const RaffleCatalog = ({
  title = "Rifas disponibles",
  getHref = (raffle) => `/rifa/${raffle.id}`,
}: RaffleCatalogProps) => {
  const accountInformation = useAppSelector(({ account }: RootState) => account);

  const { data: raffles, isLoading, isUninitialized } = useGetActiveRafflesQuery(accountInformation.id, {
    skip: accountInformation.id === "default" || accountInformation.id === "",
  });

  if (isLoading || isUninitialized) {
    return <Loading title="Buscando rifas disponibles" />;
  }

  if (!raffles || raffles.length === 0) {
    return <NoActiveRaffle logo={accountInformation.logo} />;
  }

  return (
    <Box
      sx={{
        minHeight: "80vh",
        background: "linear-gradient(135deg, #0f0f0f, #1a1a1a)",
        color: "#fff",
        px: 2,
        py: 4,
      }}
    >
      <Box display="flex" flexDirection="column" alignItems="center" mb={4}>
        <img
          src={accountInformation.logo}
          width={120}
          height={120}
          style={{ borderRadius: 20 }}
          alt="Logo"
        />
        <Typography variant="h4" mt={2} textAlign="center" fontFamily="Phrastic" sx={{ color: "white" }}>
          {title}
        </Typography>
      </Box>
      <Grid container spacing={3} justifyContent="center">
        {raffles.map((raffle) => (
          <Grid item key={raffle.id} xs={12} sm={6} md={4} lg={3} display="flex" justifyContent="center">
            <PublicRaffleCard
              raffle={raffle}
              href={getHref(raffle)}
              primaryColor={getPrimaryColorByAccountId(accountInformation.id)}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
